import { Modal, Spin, Table } from 'antd';
import { ColumnType } from 'antd/lib/table';
import _ from 'lodash';
import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dispatch } from 'redux';
import ILoanTransaction from '~Api/Loan/ILoanTransaction';
import IWarehouse from '~Api/Warehouse/IWarehouse';
import IWarehouseLoanTransaction from '~Api/Warehouse/IWarehouseLoanTransaction';
import { IGlobalState } from '~reducer';
import { IDictionary } from '~utilities/IDictionary';
import { loanTransactionSelector } from '~Loans/selectors';
import { currencyFormatter } from '~utilities/formatters';
import { warehousesListAction } from '~Warehouses/actions';
import { warehousesSelector } from '~Warehouses/selectors';
import { loanTransactionWarehouseLoanTransactionsListAction } from './actions';
import { loanTransactionWarehouseLoanTransactionsSelector } from './selectors';

interface IProps {
    isOpen: boolean;
    loanTransactionUuid: string;
    onCancel: () => void;
}

interface IPropsSelector {
    transaction: ILoanTransaction;
    warehouseLoanTransactions: IDictionary<IWarehouseLoanTransaction>;
    warehouses: IDictionary<IWarehouse>;
}

interface IPropsDispatch {
    warehouseLoanTransactionsList: () => void;
    warehousesList: () => void;
}

type Props = IProps & IPropsSelector & IPropsDispatch;

export class LoanTransactionModal extends React.Component<Props> {
    public componentDidMount(): void {
        const { warehouseLoanTransactions, warehouses } = this.props;

        if (!warehouseLoanTransactions) {
            this.props.warehouseLoanTransactionsList();
        }

        if (!warehouses) {
            this.props.warehousesList();
        }
    }

    public render(): JSX.Element {
        const { isOpen, transaction, warehouseLoanTransactions, warehouses } = this.props;

        if (!transaction || !warehouseLoanTransactions || !warehouses) {
            return (
                <Modal
                    className='accounts-loan-transaction-modal'
                    footer={false}
                    onCancel={this.props.onCancel}
                    open={isOpen}
                    title='Transaction Details'
                    wrapClassName='accounts-loan-transaction-modal-wrapper'
                    width={1000}
                >
                    <Spin/>
                </Modal>
            );
        }

        const columns: ColumnType<IWarehouseLoanTransaction>[] = [
            {
                className: 'warehouse',
                dataIndex: 'warehouseUuid',
                render: (warehouseUuid: string, warehouseLoanTransaction: IWarehouseLoanTransaction): ReactNode => warehouses[warehouseUuid] ? <Link to={`/warehouses/${warehouseUuid}/loans/${warehouseLoanTransaction.warehouseLoanUuid}`}>{warehouses[warehouseUuid].name}</Link> : '-',
                title: 'Warehouse',
            },
            {
                className: 'principal',
                dataIndex: 'amountPrincipal',
                render: (amountPrincipal: number): ReactNode => amountPrincipal > 0 ? currencyFormatter.format(amountPrincipal) : '-',
                title: 'Principal',
                width: '20%',
            },
            {
                className: 'interest',
                dataIndex: 'amountInterest',
                render: (amountInterest: number): ReactNode => amountInterest > 0 ? currencyFormatter.format(amountInterest) : '-',
                title: 'Interest',
                width: '20%',
            },
        ];

        return (
            <Modal
                className='accounts-loan-transaction-modal'
                footer={false}
                onCancel={this.props.onCancel}
                open={isOpen}
                title='Transaction Details'
                wrapClassName='accounts-loan-transaction-modal-wrapper'
                width={1000}
            >
                <Table
                    columns={columns}
                    dataSource={_.values(warehouseLoanTransactions)}
                    pagination={false}
                    rowKey='uuid'
                    size='middle'
                />
            </Modal>
        );
    }
}

function mapStateToProps(state: IGlobalState, ownProps: IProps): IPropsSelector {
    return {
        transaction: loanTransactionSelector(state, ownProps.loanTransactionUuid),
        warehouseLoanTransactions: loanTransactionWarehouseLoanTransactionsSelector(state, ownProps.loanTransactionUuid),
        warehouses: warehousesSelector(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: IProps): IPropsDispatch {
    return {
        warehouseLoanTransactionsList: () => dispatch(loanTransactionWarehouseLoanTransactionsListAction(ownProps.loanTransactionUuid)),
        warehousesList: () => dispatch(warehousesListAction()),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LoanTransactionModal);
